import { render, staticRenderFns } from "./deedItem.vue?vue&type=template&id=4ec329dd&scoped=true&"
import script from "./deedItem.vue?vue&type=script&lang=js&"
export * from "./deedItem.vue?vue&type=script&lang=js&"
import style0 from "./deedItem.vue?vue&type=style&index=0&id=4ec329dd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec329dd",
  null
  
)

export default component.exports